module.exports = __webpack_public_path__ + "static/media/cover-desktop-1220x150@2x.c916b7c9.webp";